import { render, staticRenderFns } from "./ToutiaoAdvData.vue?vue&type=template&id=ffe2e906&scoped=true"
import script from "./ToutiaoAdvData.vue?vue&type=script&lang=js"
export * from "./ToutiaoAdvData.vue?vue&type=script&lang=js"
import style0 from "./ToutiaoAdvData.vue?vue&type=style&index=0&id=ffe2e906&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe2e906",
  null
  
)

export default component.exports